module.exports = __webpack_public_path__ + "fonts/RMU-AvusProMedium-Italic.9385c4c.woff2";